import './radioButton.scss';
import {IRadioButtonProps} from "../../../models/form-controls.model";
import {useCallback} from "react";
import LabelComponent from "../../label/LabelComponent";

interface RadioButtonComponentProps extends IRadioButtonProps {

}

const RadioButtonComponent = (props: RadioButtonComponentProps) => {

    const {label, checked, name, disabled, onChange, value} = props;

    const handleRadioOnChange = useCallback((selectedValue: any) => {
        if (onChange) {
            onChange(selectedValue);
        }
    }, [onChange]);

    return (
        <div className={`radio-component ${checked ? 'checked' : ''}`}>
            <label className={`radio-container ${(disabled ? 'disable' : '')}`}>
                {label && <LabelComponent title={label || ''}/>}
                <input
                    value={value}
                    onChange={
                        (event: any) => {
                            if (handleRadioOnChange) {
                                console.log(event.target.value);
                                handleRadioOnChange(event.target.value);
                            }
                        }
                    }
                    disabled={disabled}
                    name={name}
                    checked={checked}
                    className={'radio-field'}
                    type="radio"
                />
                <span className="radio-checkmark"/>
            </label>
        </div>
    )
}

export default RadioButtonComponent;
